import React from "react";

const SinglePost = () => {
  return <div>SinglePost</div>;
};

export default SinglePost;
